export default {
    sms_system_create_title: "Crear Sistema SMS",
    sms_system_edit_title: "Editar Sistema SMS",
    sms_system_create_success_message: "Se ha creado el Sistema SMS",
    sms_system_edit_success_message: "Se ha editado el Sistema SMS",
    sms_system_same_name_exits: "Ya existe un Sistema SMS con el mismo nombre",
    sms_system_same_name_exits_edit: "Ya existe una integración Sms con el mismo nombre o prioridad",
    sms_system_name: "Nombre",
    sms_system_display_name: "Nombre para Mostrar",
    sms_system_priority: "Prioridad",
    sms_system_is_smpp: "Es SMPP",
    sms_system_status: "Estado",
}